import { useEffect, useState } from 'react';

const NextSaturdayInput =() =>{
  const [nextSaturday, setNextSaturday] = useState('');
  const getNextSaturdayFromDate = (date) => {
    
    const dayOfWeek = date.getDay(); // 0 for Sunday, 1 for Monday, etc.
    const daysUntilNextSaturday = 6 - dayOfWeek + 7; // Number of days until next Saturday
    const nextSaturday = new Date(date.getTime() + daysUntilNextSaturday * 24 * 60 * 60 * 1000);
    return nextSaturday;
  };
  
  const getCurrentFriday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 for Sunday, 1 for Monday, etc.
    const daysUntilFriday = dayOfWeek <= 5 ? 5 - dayOfWeek : 5 + (7 - dayOfWeek); // Number of days until Friday
    const currentFriday = new Date(today.getTime() + daysUntilFriday * 24 * 60 * 60 * 1000);
    return currentFriday;
  };
  useEffect(() => {
    const today = new Date();
    //console.log(today);
    let dayOfWeek = today.getDay();
    let nextSaturdayDate;
    console.log(dayOfWeek);
    //dayOfWeek=0;
    let formattedNextSaturday;
    // Calculate the number of days until the next Saturday
    if (dayOfWeek >= 5) {
      // If today is Saturday, set it to the next Saturday
      const today = new Date();
      const friday = getCurrentFriday();
      const saturday = getNextSaturdayFromDate(today);
      console.log(saturday);
      nextSaturdayDate=saturday;
    
    } else { 
      const today = new Date();
      let daysUntilSaturday = 6 - today.getDay();
      nextSaturdayDate = new Date(today.getTime() + daysUntilSaturday * 24 * 60 * 60 * 1000);
    }
  formattedNextSaturday =  `${String(nextSaturdayDate.getDate()).padStart(2, '0')}-${String(nextSaturdayDate.getMonth() + 1).padStart(2, '0')}-${nextSaturdayDate.getFullYear()}`;
  setNextSaturday(formattedNextSaturday);
  }, []);
  return <input type="text" name="dateofappointment" className="form-control" value={nextSaturday} readOnly />;
}

export default NextSaturdayInput;